var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fx-row fx-row-middle",staticStyle:{"width":"100%"}},[(!_vm.chartData.length)?_c('div',{staticClass:"text"},[_vm._v("暂无数据")]):_vm._e(),_c('div',{staticStyle:{"width":"100%","height":"300px"},attrs:{"id":_vm.chartId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }